export default {
    url: '',
    template: '<ui-view></ui-view>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/skill/add/index.js